// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.health-container {
  display: block;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group {
  height: 36px;
}

.filter-section {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 1rem;
}

.filter-input {
  width: 150px;
  height: 36px;
  overflow-y: auto;
  padding: 8px 12px;
  border-radius: 0.5rem;
  border: 1px solid #d3d3d3;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 6px), calc(100% - 15px) calc(1em + 6px), calc(100% - 2.5em) 0.9em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

.filter-input option {
  max-height: 200px; /* Controls the dropdown height */
}

.filter-title {
  display: flex;
  white-space: nowrap;
  font-size: 0.825rem;
  font-weight: 600;
  color: #121212;
}

.filter-container {
  background-color: #eff3ff;
  padding: 0.25rem;
  display: flex;
  justify-content: flex-end;
  border-radius: 6px;
  margin-bottom: 0.5rem;
}

.year-filter {
  width: 60%;
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
}

.project-filteration {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  align-items: baseline;
}

.border-bottom {
  display: block;
  width: 100%;
  padding-bottom: 0.25rem;
  margin-bottom: 0.25rem;
  border-bottom: 1px solid #ccc;
}

.brand-overview {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.725rem;
}

.brand-overview .section-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 1.5rem;
  color: #2f2f2f;
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 0;
}

.brand-dqscores {
  display: flex;
  gap: 1rem;
  overflow-x: scroll;
}

.score-list {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 0.825rem;
  margin: 0.25rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1;
  min-width: 270px;
  position: relative;
  overflow: hidden;
}

.score-list:first-child::before {
  content: none;
}

.score-list::before {
  position: absolute;
  top: 50%;
  left: 0px;
  display: block;
  content: "";
  height: 200%;
  aspect-ratio: 1/1;
  transform: translate(-30%, -60%);
  border-radius: 50%;
  background-color: rgb(191, 209, 255);
  opacity: 0.25;
}

.metric-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  width: 48px;
  height: 48px;
  border-radius: 6px;
  box-shadow: rgba(50, 50, 93, 0.2) 0px 10px 20px -10px, rgba(0, 0, 0, 0.25) 0px 10px 20px 0px;
  z-index: 2;
  background-color: #fff;
}

.score-details {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  width: calc(100% - 50px);
  line-height: 2;
}

.brand-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  color: #0d47a0;
  line-height: 1;
  height: 24px;
}

.brand-subtitle {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.9);
  line-height: 1;
  white-space: nowrap;
  margin-bottom: 4px;
}

.brand-subcategory {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  color: rgba(51, 51, 51, 0.8);
  line-height: 1;
  padding-top: 4px;
}

.brand-subcategory-list {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.75rem;
  color: #121212;
  line-height: 1.5;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  flex-basis: auto;
  white-space: nowrap;
  width: auto;
  max-width: 75%;
}

.tab-container {
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
  padding: 1rem;
  margin-top: 1.5rem;
  background-color: #fff;
}

.overview-box {
  border: 1px solid #e0e3e8;
  border-radius: 8px;
  margin-bottom: 1rem;
  background-color: #fff;
}

.basemedia {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0.5rem;
}
.basemedia .score-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  color: #2f2f2f;
}
.basemedia .score-titlesmall {
  display: flex;
  flex: 1 1;
}
.basemedia .brand-title {
  color: #2f2f2f;
  font-size: 1.5rem;
}

.score-name {
  display: flex;
  flex-direction: column;
}

.box-title {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 0.875rem;
  color: #2f2f2f;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
}
.box-title small {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  display: flex;
  flex: 1 1;
}

.score-table {
  border: none;
}
.score-table p {
  margin-bottom: 0.5rem;
  font-size: 0.815rem;
}
.score-table .score-subscores {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  display: flex;
  font-size: 0.815rem;
  color: #2f2f2f;
  margin-bottom: 0.5rem;
  line-height: 1.25;
  padding-left: 0.25rem;
}

.percentile-score {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  color: #0d47a0;
  font-size: 1rem;
  display: flex;
  position: absolute;
  top: -15px;
  right: 0;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  line-height: 1;
}

.percentile-score:nth-child(1) {
  bottom: -20px;
  top: inherit;
}

.percentile-subtitle {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 0.725rem;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1;
}

.score-diff {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  display: flex;
  position: absolute;
  bottom: -4px;
  right: 0;
  align-items: center;
  gap: 4px;
}

.no-data-found {
  height: calc(100vh - 440px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 440px);
}

.loader {
  border: 3px solid #e5e5e5;
  border-radius: 50%;
  border-top: 3px solid #0d47a0;
  aspect-ratio: 1;
  width: 28px;
  height: 28px; /* Safari */
  animation: spin 1.5s linear infinite;
}

.loader-text {
  font-size: 1rem;
  color: #0d47a0;
  line-height: 1;
  display: block;
}

/* Safari */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 767px) {
  .title-section,
  .filter-section {
    flex-direction: column;
    align-items: flex-start;
  }
  .title-section {
    margin-bottom: 1rem;
  }
  .brand-overview {
    overflow: hidden;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .title-section {
    flex-direction: column;
    align-items: flex-start;
  }
  .filter-section {
    flex-wrap: wrap;
  }
  .title-section {
    margin-bottom: 1rem;
  }
  .brand-overview {
    overflow: hidden;
  }
}
.brand-header {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
}
.brand-header .competitor {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.brand-header .competitor .competitor-title {
  font-size: 16px;
}
.brand-header .competitor .competitor-list {
  list-style-type: none;
  display: flex;
  padding: 0;
  margin: 0;
  gap: 0.75rem;
  align-items: baseline;
  justify-content: flex-start;
}

.comptetitor-item {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: start;
}
.comptetitor-item li {
  position: relative;
}
.comptetitor-item li .brand-list {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  font-weight: 700;
  position: relative;
}
.comptetitor-item li:before {
  content: "";
  width: 1px;
  height: 16px;
  background-color: #333;
  position: absolute;
  top: 4px;
  right: -4px;
}
.comptetitor-item li:last-child::before {
  content: "";
  display: none;
}

.custom-tabs.healthcard-tab .tab-content {
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/mixins/fonts.scss","webpack://./src/pages/healthcard/overview/HealthCardOverview.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/mixins.scss","webpack://./src/assets/mixins/colors.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ACAF;ADEA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ACDF;ACbA;;;EAGE,sBAAA;ADeF;;ACZA;EACE,SAAA;EACA,UAAA;ADeF;;ACZA;;EAEE,gBAAA;ADeF;;ACZA;EACE,uBAAA;ADeF;;ACZA;EACE,8BAAA;ADeF;;ACZA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;ADeF;;ACZA;;;;EAIE,aAAA;ADeF;;ACZA;EACE;IACE,qBAAA;EDeF;ECbA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EDeF;AACF;ACZA;;EAEE,YAAA;EACA,uBAAA;ADcF;;AA3EA;EACE,cAAA;AA8EF;;AA5EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA+EF;;AA7EA;EACE,YAAA;AAgFF;;AA9EA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;AAiFF;;AA/EA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EAGA,gBAAA;EACA,8JAAA;EAGA,mHAAA;EAEA,4CAAA;EACA,4BAAA;AA+EF;;AA7EA;EACE,iBAAA,EAAA,iCAAA;AAgFF;;AA9EA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAiFF;;AA/EA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAkFF;;AAhFA;EACE,UAAA;EACA,aAAA;EACA,WAAA;EAEA,qBAAA;AAkFF;;AAhFA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;AAmFF;;AAjFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;AAoFF;;AAlFA;EEvEE,sBCCM;EDAN,qBAAA;EACA,wCAAA;EFuEA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAuFF;;AArFA;EDrDE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECoDA,iBAAA;EACA,cG/EW;EHgFX,aAAA;EACA,sBAAA;EACA,MAAA;EACA,gBAAA;AA2FF;;AAzFA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AA4FF;;AAzFA;EAKE,yHAAA;EAEA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAuFF;;AArFA;EACE,aAAA;AAwFF;;AAtFA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;AAyFF;;AAvFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,4FAAA;EAEA,UAAA;EACA,sBAAA;AAwFF;;AAtFA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,wBAAA;EAEA,cAAA;AAwFF;;AAtFA;ED/HE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC8HA,gBAAA;EACA,iBAAA;EACA,cG/Jc;EHgKd,cAAA;EACA,YAAA;AA4FF;;AA1FA;ED7IE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC4IA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAgGF;;AA9FA;EDrJE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECoJA,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AAoGF;;AAlGA;ED5JE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC2JA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAwGF;;AAtGA;EE5LE,sBCCM;EDAN,qBAAA;EACA,wCAAA;EF4LA,aAAA;EACA,kBAAA;EACA,sBG/LM;AH0SR;;AAtGA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAyGF;;AAvGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AA0GF;AAzGE;EDxLA,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECuLE,mBAAA;EACA,cGlNS;AHgUb;AA7GI;EACE,aAAA;EACA,SAAA;AA+GN;AA5GE;EACE,cGzNS;EH0NT,iBAAA;AA8GJ;;AA3GA;EACE,aAAA;EACA,sBAAA;AA8GF;;AA5GA;ED1ME,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECyMA,mBAAA;EACA,cGpOW;EHqOX,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AAkHF;AAjHE;EDxNA,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECuNE,aAAA;EACA,SAAA;AAsHJ;;AAnHA;EACE,YAAA;AAsHF;AArHE;EACE,qBAAA;EACA,mBAAA;AAuHJ;AArHE;ED9NA,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC6NE,aAAA;EACA,mBAAA;EACA,cGzPS;EH0PT,qBAAA;EACA,iBAAA;EACA,qBAAA;AA0HJ;;AAvHA;EDxOE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECuOA,cGtQc;EHuQd,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AA6HF;;AA1HA;EACE,aAAA;EACA,YAAA;AA6HF;;AA3HA;EDhQE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC+PA,mBAAA;EACA,yBAAA;EACA,cAAA;AAiIF;;AA/HA;EDtQE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ECqQA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,QAAA;AAqIF;;AAnIA;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsIF;;AApIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAuIF;;AArIA;EACE,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA,EACA,WAAA;EACA,oCAAA;AAwIF;;AAtIA;EACE,eAAA;EACA,cG/Tc;EHgUd,cAAA;EACA,cAAA;AAyIF;;AAtIA,WAAA;AAUA;EACE;IACE,uBAAA;EAwIF;EAtIA;IACE,yBAAA;EAwIF;AACF;AArIA;EACE;;IAEE,sBAAA;IACA,uBAAA;EAuIF;EArIA;IACE,mBAAA;EAuIF;EArIA;IACE,gBAAA;EAuIF;AACF;AApIA;EACE;IACE,sBAAA;IACA,uBAAA;EAsIF;EApIA;IACE,eAAA;EAsIF;EApIA;IACE,mBAAA;EAsIF;EApIA;IACE,gBAAA;EAsIF;AACF;AAnIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAqIF;AApIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAsIJ;AArII;EACE,eAAA;AAuIN;AArII;EACE,qBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AAuIN;;AAnIA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AAsIF;AArIE;EACE,kBAAA;AAuIJ;AAtII;ED5XF,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EC2XI,eAAA;EACA,gBAAA;EACA,kBAAA;AA2IN;AAzII;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AA2IN;AAzII;EACE,WAAA;EACA,aAAA;AA2IN;;AAvIA;EACE,aAAA;AA0IF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.health-container {\n  display: block;\n}\n\n.title-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.btn-group {\n  height: 36px;\n}\n\n.filter-section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: baseline;\n  gap: 1rem;\n}\n\n.filter-input {\n  width: 150px;\n  height: 36px;\n  overflow-y: auto;\n  padding: 8px 12px;\n  border-radius: 0.5rem;\n  border: 1px solid #d3d3d3;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);\n  background-position: calc(100% - 20px) calc(1em + 6px), calc(100% - 15px) calc(1em + 6px), calc(100% - 2.5em) 0.9em;\n  background-size: 5px 5px, 5px 5px, 1px 1.5em;\n  background-repeat: no-repeat;\n}\n\n.filter-input option {\n  max-height: 200px; /* Controls the dropdown height */\n}\n\n.filter-title {\n  display: flex;\n  white-space: nowrap;\n  font-size: 0.825rem;\n  font-weight: 600;\n  color: #121212;\n}\n\n.filter-container {\n  background-color: #eff3ff;\n  padding: 0.25rem;\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 6px;\n  margin-bottom: 0.5rem;\n}\n\n.year-filter {\n  width: 60%;\n  display: flex;\n  gap: 0.5rem;\n  align-items: baseline;\n}\n\n.project-filteration {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  align-items: baseline;\n}\n\n.border-bottom {\n  display: block;\n  width: 100%;\n  padding-bottom: 0.25rem;\n  margin-bottom: 0.25rem;\n  border-bottom: 1px solid #ccc;\n}\n\n.brand-overview {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.725rem;\n}\n\n.brand-overview .section-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 1.5rem;\n  color: #2f2f2f;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 0;\n}\n\n.brand-dqscores {\n  display: flex;\n  gap: 1rem;\n  overflow-x: scroll;\n}\n\n.score-list {\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  padding: 0.825rem;\n  margin: 0.25rem;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  min-width: 270px;\n  position: relative;\n  overflow: hidden;\n}\n\n.score-list:first-child::before {\n  content: none;\n}\n\n.score-list::before {\n  position: absolute;\n  top: 50%;\n  left: 0px;\n  display: block;\n  content: \"\";\n  height: 200%;\n  aspect-ratio: 1/1;\n  transform: translate(-30%, -60%);\n  border-radius: 50%;\n  background-color: rgb(191, 209, 255);\n  opacity: 0.25;\n}\n\n.metric-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  width: 48px;\n  height: 48px;\n  border-radius: 6px;\n  box-shadow: rgba(50, 50, 93, 0.2) 0px 10px 20px -10px, rgba(0, 0, 0, 0.25) 0px 10px 20px 0px;\n  z-index: 2;\n  background-color: #fff;\n}\n\n.score-details {\n  display: flex;\n  align-items: baseline;\n  flex-direction: column;\n  justify-content: flex-start;\n  position: relative;\n  width: calc(100% - 50px);\n  line-height: 2;\n}\n\n.brand-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5rem;\n  color: #0d47a0;\n  line-height: 1;\n  height: 24px;\n}\n\n.brand-subtitle {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.9);\n  line-height: 1;\n  white-space: nowrap;\n  margin-bottom: 4px;\n}\n\n.brand-subcategory {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 0.75rem;\n  color: rgba(51, 51, 51, 0.8);\n  line-height: 1;\n  padding-top: 4px;\n}\n\n.brand-subcategory-list {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 0.75rem;\n  color: #121212;\n  line-height: 1.5;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: inline-block;\n  flex-basis: auto;\n  white-space: nowrap;\n  width: auto;\n  max-width: 75%;\n}\n\n.tab-container {\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n  padding: 1rem;\n  margin-top: 1.5rem;\n  background-color: #fff;\n}\n\n.overview-box {\n  border: 1px solid #e0e3e8;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  background-color: #fff;\n}\n\n.basemedia {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem 0.5rem;\n}\n.basemedia .score-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 0.875rem;\n  color: #2f2f2f;\n}\n.basemedia .score-titlesmall {\n  display: flex;\n  flex: 1;\n}\n.basemedia .brand-title {\n  color: #2f2f2f;\n  font-size: 1.5rem;\n}\n\n.score-name {\n  display: flex;\n  flex-direction: column;\n}\n\n.box-title {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 0.875rem;\n  color: #2f2f2f;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-top: 1rem;\n}\n.box-title small {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  display: flex;\n  flex: 1;\n}\n\n.score-table {\n  border: none;\n}\n.score-table p {\n  margin-bottom: 0.5rem;\n  font-size: 0.815rem;\n}\n.score-table .score-subscores {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  display: flex;\n  font-size: 0.815rem;\n  color: #2f2f2f;\n  margin-bottom: 0.5rem;\n  line-height: 1.25;\n  padding-left: 0.25rem;\n}\n\n.percentile-score {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  color: #0d47a0;\n  font-size: 1rem;\n  display: flex;\n  position: absolute;\n  top: -15px;\n  right: 0;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-end;\n  line-height: 1;\n}\n\n.percentile-score:nth-child(1) {\n  bottom: -20px;\n  top: inherit;\n}\n\n.percentile-subtitle {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 0.725rem;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 1;\n}\n\n.score-diff {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 400;\n  font-style: normal;\n  display: flex;\n  position: absolute;\n  bottom: -4px;\n  right: 0;\n  align-items: center;\n  gap: 4px;\n}\n\n.no-data-found {\n  height: calc(100vh - 440px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 440px);\n}\n\n.loader {\n  border: 3px solid #e5e5e5;\n  border-radius: 50%;\n  border-top: 3px solid #0d47a0;\n  aspect-ratio: 1;\n  width: 28px;\n  height: 28px;\n  -webkit-animation: spin 1.5s linear infinite; /* Safari */\n  animation: spin 1.5s linear infinite;\n}\n\n.loader-text {\n  font-size: 1rem;\n  color: #0d47a0;\n  line-height: 1;\n  display: block;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@media (max-width: 767px) {\n  .title-section,\n  .filter-section {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .title-section {\n    margin-bottom: 1rem;\n  }\n  .brand-overview {\n    overflow: hidden;\n  }\n}\n@media (min-width: 768px) and (max-width: 1199px) {\n  .title-section {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .filter-section {\n    flex-wrap: wrap;\n  }\n  .title-section {\n    margin-bottom: 1rem;\n  }\n  .brand-overview {\n    overflow: hidden;\n  }\n}\n.brand-header {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.brand-header .competitor {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n.brand-header .competitor .competitor-title {\n  font-size: 16px;\n}\n.brand-header .competitor .competitor-list {\n  list-style-type: none;\n  display: flex;\n  padding: 0;\n  margin: 0;\n  gap: 0.75rem;\n  align-items: baseline;\n  justify-content: flex-start;\n}\n\n.comptetitor-item {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: start;\n}\n.comptetitor-item li {\n  position: relative;\n}\n.comptetitor-item li .brand-list {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 14px;\n  font-weight: 700;\n  position: relative;\n}\n.comptetitor-item li:before {\n  content: \"\";\n  width: 1px;\n  height: 16px;\n  background-color: #333;\n  position: absolute;\n  top: 4px;\n  right: -4px;\n}\n.comptetitor-item li:last-child::before {\n  content: \"\";\n  display: none;\n}\n\n.custom-tabs.healthcard-tab .tab-content {\n  padding: 1rem;\n}","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","@import \"variables\", \"colors\", \"fonts\", \"reset\";\r\n\r\n@mixin boxWithShadow() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 13%);\r\n}\r\n@mixin brandScores() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 12%);\r\n  padding: 0.675rem;\r\n}\r\n\r\n@mixin pageTitle() {\r\n  @include primeFont();\r\n  font-size: 2rem;\r\n  color: $primary-color;\r\n  line-height: 2.5rem;\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@mixin boxSubTitle() {\r\n  @include secondaryFontBold;\r\n  font-size: 1rem;\r\n  color: $text-color;\r\n  line-height: 1.2;\r\n  margin-bottom: .875rem;\r\n  display: flex;\r\n}","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
